import { OrbType } from "../..";
export class ComboStrippedStripped {
    constructor(board, p1, p2) {
        if (p1.c === p2.c) {
            board[p1.c][p1.r].type = OrbType.STRIPPED_VER;
            board[p2.c][p2.r].type = OrbType.STRIPPED_HOR;
            this.eliminatedOrbs = [
                {
                    p: p1,
                    type: OrbType.STRIPPED_VER,
                    n: 0,
                    triggeringOrbColor: null,
                    collapsing: false,
                    collapsingPosition: null,
                    isComboWrappedWrappedOrb: false,
                    pBomb: null
                },
                {
                    p: p2,
                    type: OrbType.STRIPPED_HOR,
                    n: 0,
                    triggeringOrbColor: null,
                    collapsing: false,
                    collapsingPosition: null,
                    isComboWrappedWrappedOrb: false,
                    pBomb: null
                },
            ];
        }
        else {
            board[p1.c][p1.r].type = OrbType.STRIPPED_HOR;
            board[p2.c][p2.r].type = OrbType.STRIPPED_VER;
            this.eliminatedOrbs = [
                {
                    p: p1,
                    type: OrbType.STRIPPED_HOR,
                    n: 0,
                    triggeringOrbColor: null,
                    collapsing: false,
                    collapsingPosition: null,
                    isComboWrappedWrappedOrb: false,
                    pBomb: null
                },
                {
                    p: p2,
                    type: OrbType.STRIPPED_VER,
                    n: 0,
                    triggeringOrbColor: null,
                    collapsing: false,
                    collapsingPosition: null,
                    isComboWrappedWrappedOrb: false,
                    pBomb: null
                },
            ];
        }
    }
    getEliminatedOrbs() {
        return this.eliminatedOrbs;
    }
    getSpecialOrbsAffected() {
        return this.eliminatedOrbs;
    }
}
//# sourceMappingURL=data:application/json;base64,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